// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_4hg","cls2":"ClaimEvaluationRow-cls2_WIK ClaimEvaluationRow-cls1_4hg","expanded":"ClaimEvaluationRow-expanded_8_0"};